import { Title } from '@winnin/winnin_ui.components.title'

import { ChartPrintProvider } from 'contexts/ChartPrintContext'
import { useTranslate } from 'lib/tolgee'
import { translations as nicheTranslations } from 'modules/niche/common/niche.i18n'
import { NicheCardList } from 'modules/niche/niche-card-list'
import { NicheChartSelector } from 'modules/niche/niche-chart-selector'
import { NicheEmptyState } from 'modules/niche/niche-empty-state'
import { NicheError } from 'modules/niche/niche-error'
import TOLGEE_GLOBALS from 'utils/tolgeeGlobals'

import type { ITaxonomyChildrenTab } from './taxonomy-children-tab.types'
import './taxonomy-children-tab.styles.scss'

export const TaxonomyChildrenTabView = ({
  feature,
  territoryName,
  nicheList,
  isLoading,
  hasError,
  isEmpty,
  onRetry,
  isTotalsLoading,
  territoryIds,
  nichesWithPerformance,
  isChartReady,
  chartUniverseData,
  hasReachedSelectedNicheLimit,
  shouldDisplayResetButton,
  handleReset,
}: ITaxonomyChildrenTab) => {
  const t = useTranslate()

  if (hasError) {
    return (
      <div className="TaxonomyChildrenTab" data-testid="taxonomy-children-tab-error">
        <NicheError onRetry={onRetry} />
      </div>
    )
  }

  if (isEmpty) {
    return (
      <div className="TaxonomyChildrenTab" data-testid="taxonomy-children-tab-empty">
        <NicheEmptyState contextName={territoryName} isDefaultContext />
      </div>
    )
  }

  return (
    <div className="TaxonomyChildrenTab" data-testid="taxonomy-children-tab">
      <div className="TaxonomyChildrenTab-content">
        <div>
          <div className="TaxonomyChildrenTab-listTitleRow">
            <Title tag="h3">{t(nicheTranslations.compareThemes)}</Title>
            {shouldDisplayResetButton && (
              <button
                className="TaxonomyChildrenTab-resetButton"
                onClick={handleReset}
                data-testid="taxonomy-children-tab-reset"
              >
                {t(TOLGEE_GLOBALS.reset)}
              </button>
            )}
          </div>
          <NicheCardList
            niches={nicheList}
            error={false}
            loading={isLoading}
            refetch={onRetry}
            hasReachedSelectedNicheLimit={hasReachedSelectedNicheLimit}
            isNichePending={false}
            feature={feature}
          />
        </div>
        <div className="TaxonomyChildrenTab-charts">
          <ChartPrintProvider>
            <NicheChartSelector
              nichesWithPerformance={nichesWithPerformance}
              territoryIds={territoryIds}
              chartDataUniverse={chartUniverseData}
              isChartReady={isChartReady}
              chartDataLoading={isTotalsLoading}
              chartDataError={false}
              chartDataRefetch={onRetry}
            />
          </ChartPrintProvider>
        </div>
      </div>
    </div>
  )
}
